<template>
  <div class="body-content">

   <div class="manual-wrap active" @touchmove.prevent v-if="manuals.length>0">
     <turn :width="800" ref="turn" :height="800" :data="manuals" @change="handleTurnChange"></turn>
   </div>
   <div class="manual-wrap" v-else>
     暂无数据~
   </div>

  </div>
</template>
<script>
  import { pdf_detail} from '@/api/api.js'
  // import {
  //   turn
  // } from '@/assets/js/turn.js'
  import turn from "vue-flip-page";
  export default {
    name: "FenMian2",
    data() {
      return {
        id: '', //详情id
        company_id: '', //电子书ID
        per_page: 10,
        page: 1,
        total: '',
        value: "",
        //电子书列表
        allPages: [],
        currentIndex:0,
        manuals: [

		]
      };
    },
    mounted() {
		this.id = this.$route.query.id
		this.detail(this.id)
    },
    methods: {
		//月刊详情，图片列表
		detail(id) {
		  let data = {
		    id: id
		  }
		  pdf_detail(data).then(res => {
		    // console.log(res.data, "===");
		    if (res.code == 1) {
		      let allPages = res.data.cn_pdf_arr
			  this.manuals= allPages.map(item=>({"picture_image":item}))
		    }
		  }).catch(err => {});
		},
		
		  handleTurnChange(index) {
			  console.log(index);
			if (index === this.currentIndex) return;
			this.$refs["turn"].toPage(index);
			this.currentIndex = index;
			this.goods_id = this.manuals[this.currentIndex].goods_id;
			this.show = false;
		  }
    },
    components: {
      turn
    }
  };
</script>
<style scoped>
  body {
    background: #ccc;
    height: 100vh;
    overflow: hidden;
  }

  .manual-wrap {
    position: relative;
    z-index: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    opacity: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-transform: scale(0.95);
    transform: scale(0.95);
    -webkit-transition: opacity ease 0.5s;
    transition: opacity ease 0.5s;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -o-user-select: none;
  }

  .manual-wrap.active {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
</style>
